// export const getDomain = () => {
//     if (typeof window === 'undefined') return 'domain1.com';
//     const host = window.location.hostname;
//     if (host.includes('domain1.com')) return 'domain1.com';
//     if (host.includes('domain2.com')) return 'domain2.com';
//     return 'domain1.com';
// };


export const getDomain = () => {
    if (typeof window === 'undefined') return 'app.onlinemasterscolleges.com';

    const host = window.location.hostname;

    if (host.includes('app.onlinemasterscolleges.com')) return 'app.onlinemasterscolleges.com';
    if (host.includes('domain2.com')) return 'domain2.com';

    // default fallback
    return 'app.onlinemasterscolleges.com';
};
